export default "__VITE_ASSET__tj3br3Mm__"